import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './OrderConfirmationPage.css';

const OrderConfirmationPage: React.FC = () => {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const { clearCart } = useCart();

  // Clear cart once the confirmation page loads
  useEffect(() => {
    clearCart();
  }, [clearCart]);

  return (
    <div className="order-confirmation">
      <div className="order-confirmation__inner">
        <div className="order-confirmation__icon" aria-hidden="true">✓</div>
        <h1 className="order-confirmation__title">Order received.</h1>
        <p className="order-confirmation__body">
          Thank you for your order. A confirmation email is on its way.
          {sessionId && (
            <span className="order-confirmation__ref">
              {' '}Reference: <code>{sessionId.slice(-8)}</code>
            </span>
          )}
        </p>
        <div className="order-confirmation__actions">
          <Link to="/fragrance" className="order-confirmation__btn-primary">
            Continue Shopping
          </Link>
          <Link to="/" className="order-confirmation__btn-secondary">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmationPage;
